import { render } from "./OperatorDashboard.vue?vue&type=template&id=53d66e3f&scoped=true"
import script from "./OperatorDashboard.vue?vue&type=script&lang=js"
export * from "./OperatorDashboard.vue?vue&type=script&lang=js"

import "./OperatorDashboard.vue?vue&type=style&index=0&id=53d66e3f&scoped=true&lang=css"

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d66e3f"]])

export default __exports__